import {
    APP_INITIALIZER,
    ApplicationConfig,
    importProvidersFrom
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
    HttpClientModule,
    provideHttpClient,
    withInterceptors
} from '@angular/common/http';
import { loggerInterceptor, traceInterceptor } from '@nagel-utils';
import { KeycloakService } from '@nagel-services';
import { environment } from 'apps/nagel-cal-disposition/environment/environment';
import { KeycloakOptions } from 'keycloak-angular';

function initializeKeycloak(keycloak: KeycloakService) {
    const { keycloak: keycloakConfig, sessionRenewalTime } = environment;

    return () => keycloak.init(keycloakConfig as KeycloakOptions, sessionRenewalTime);
}

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes),
        importProvidersFrom(BrowserAnimationsModule),
        importProvidersFrom(HttpClientModule),
        KeycloakService,
        provideHttpClient(
            withInterceptors([loggerInterceptor, traceInterceptor])
        ),
        {
            provide: APP_INITIALIZER,
            useFactory: initializeKeycloak,
            multi: true,
            deps: [KeycloakService]
        }
    ]
};